import {
  ENVIRONMENT_TOKEN,
  ILoggingEvent,
  ILoggingService,
  USER_ROLE_SERVICE_TOKEN,
} from '@aksia/infrastructure';
import { ErrorHandler, inject, Injectable, signal } from '@angular/core';
import * as Sentry from '@sentry/angular';

@Injectable({ providedIn: 'root' })
export class LoggingService implements ILoggingService, ErrorHandler {
  //#region Injections

  private readonly environment = inject(ENVIRONMENT_TOKEN);
  private readonly userRoleService = inject(USER_ROLE_SERVICE_TOKEN, {
    optional: true,
  });

  //#endregion

  //#region Properties

  private readonly activeEvent = signal<Partial<ILoggingEvent> | undefined>(
    undefined,
  );

  static title: string | undefined = undefined;

  //#endregion

  static resolveUserInteraction(
    category: string,
    target: HTMLElement,
  ): string | null {
    if (category === 'ui.click') {
      let logTarget = target.hasAttribute('uilog')
        ? target
        : target.closest('[uilog]');

      if (!logTarget) {
        return null;
      }

      let uilog = logTarget.getAttribute('uilog');
      let controlType = logTarget?.tagName.toLowerCase();
      return `${controlType}: ${uilog ?? 'unlogged'}`;
    } /* else if (category === 'ui.input') {
      console.log('input event', target.innerText);
    } */

    return null;
  }

  constructor() {
    /* Sentry.init({
      dsn: 'https://14285a2721dc7e115e9debe91ab82520@o462085.ingest.us.sentry.io/4510119256522752',
      environment: this.environment.environment_variable,
      debug: this.environment.environment_variable !== 'production',
      release: this.environment.version,
      beforeBreadcrumb(breadcrumb, hint) {
        if (breadcrumb.category === 'console') {
          return null;
        } else {
          let target = (hint?.['event'] as PointerEvent)?.target as HTMLElement;
          if (!target) return null;
          let breadcrumbMessage = LoggingService.resolveUserInteraction(
            breadcrumb.category!,
            target,
          );
          if (!breadcrumbMessage) return null;
          breadcrumb.message = breadcrumbMessage;
        }

        return breadcrumb;
      },
    })?.addEventProcessor((event: Sentry.Event) => {
      event.tags = { ...event.tags, application: this.environment.title };
      event.user = {
        id: this.userRoleService?.activeUser()?.userId?.toString(),
        email: this.userRoleService?.activeUser()?.email,
        username: this.userRoleService?.activeUser()?.userName,
      };
      return event;
    }); */
  }

  //handleError(error: Error, errorName?: string, data?: any) {
  handleError(event: ILoggingEvent | Error) {
    console.error(event);
    /* if (event instanceof Error) {
      let sentryError = event;
      sentryError.name = event.name ?? 'Unknown Error';
      Sentry.captureException(sentryError);
      return;
    } else {
      let sentryError = new Error(event.message);
      sentryError.name = event.title ?? 'Unknown Error';
      Sentry.captureException(sentryError, {
        extra: event.extra,
      });
    } */
  }

  handleMessage(event: ILoggingEvent) {
    /* Sentry.captureMessage(event.title!, event.level); */
  }
}
